module.exports = __webpack_public_path__ + "static/media/python.0d8052ac.svg";